class OnimaskCountdown extends HTMLElement {
  connectedCallback() {
    this.end = this.dataset.end;
    if (!this.end) return;

    this.valueNodes = {
      days: this.querySelector('[data-countdown-days]'),
      hours: this.querySelector('[data-countdown-hours]'),
      minutes: this.querySelector('[data-countdown-minutes]'),
      seconds: this.querySelector('[data-countdown-seconds]'),
    };

    this.tick();
    this.timer = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
  }

  tick() {
    const endTime = new Date(this.end).getTime();
    const now = Date.now();
    let diff = endTime - now;

    if (Number.isNaN(endTime) || diff <= 0) {
      this.render(0, 0, 0, 0);
      this.classList.add('is-expired');
      if (this.timer) window.clearInterval(this.timer);
      return;
    }

    const days = Math.floor(diff / 86400000);
    diff -= days * 86400000;
    const hours = Math.floor(diff / 3600000);
    diff -= hours * 3600000;
    const minutes = Math.floor(diff / 60000);
    diff -= minutes * 60000;
    const seconds = Math.floor(diff / 1000);

    this.render(days, hours, minutes, seconds);
  }

  render(days, hours, minutes, seconds) {
    if (this.valueNodes.days) this.valueNodes.days.textContent = String(days).padStart(2, '0');
    if (this.valueNodes.hours) this.valueNodes.hours.textContent = String(hours).padStart(2, '0');
    if (this.valueNodes.minutes) this.valueNodes.minutes.textContent = String(minutes).padStart(2, '0');
    if (this.valueNodes.seconds) this.valueNodes.seconds.textContent = String(seconds).padStart(2, '0');
  }
}

customElements.define('onimask-countdown', OnimaskCountdown);
